
/* eslint-disable @typescript-eslint/no-var-requires */
import Vue from "vue";
import { mapState } from "vuex";
import { dispatch } from "@/store";
import { download } from "@/utils";
const amMasterAssetDir = "https://cdn-www.angrymiao.com/am_master_web_new/";
const kvHeroDesktop = `${amMasterAssetDir}am_master_web_new_hero_desktop.png`;
const kvHeroMobile = `${amMasterAssetDir}am_master_web_new_hero_mobile.png`;
const marathonCollageImage = `${amMasterAssetDir}am_master_web_new_marathon.png`;
const devicesImage = `${amMasterAssetDir}am_master_web_new_devices.png`;
const hardwareImage = `${amMasterAssetDir}am_master_web_new_08.png`;
const hardwareImageMobile = `${amMasterAssetDir}am_master_web_new_08_mobile.png`;
const mappingImage = `${amMasterAssetDir}am_master_web_new_12.png`;
const deviceImage = `${amMasterAssetDir}am_master_web_new_15.png`;
const upgradeImage = `${amMasterAssetDir}am_master_web_new_18.png`;

export default Vue.extend({
  data() {
    return {
      kvHeroDesktop,
      kvHeroMobile,
      marathonCollageImage,
      devicesImage,
      hardwareImage,
      hardwareImageMobile,
      mappingImage,
      deviceImage,
      upgradeImage
    };
  },
  computed: {
    ...mapState("app", { isCN: "isCN", isMobile: "isMobile" }),
    localDevices(): string[] {
      return (this.$t("AMMasterNew.compatLocalItems") as string).split("|");
    },
    noticeItems(): string[] {
      return (this.$t("AMMasterNew.noticeItems") as string)
        .split("|")
        .map((item, index) => `${index + 1}.${item}`);
    }
  },
  methods: {
    titleParts(key: string): string[] {
      if (!this.isCN) return [this.$t(`AMMasterNew.${key}`) as string];
      const lines: Record<string, string[]> = {
        heroTitle: ["全新网页版", "免安装，零占用。"],
        title02: ["灵感源自《马拉松》", "的极简操控界面"],
        title03: ["怒喵核心硬件设备", "固件统一管理"],
        title04: ["所见即所得", "实时参数同步"],
        title05: ["设备即插即识", "云端/本地秒级响应"],
        title06: ["无感检测", "一键云端升级"],
        title07: ["注意事项"]
      };
      return lines[key] || [this.$t(`AMMasterNew.${key}`) as string];
    },
    openWeb() {
      window.open("https://diy.angrymiao.com/device-connect/", "_blank");
    },
    openLegacy() {
      window.open("https://www.angrymiao.com/am-master/", "_blank");
    },
    onDownload(platform: "windows" | "mac") {
      dispatch
        .diyGetAMMaster(platform)
        .then(res => {
          if (res.data && res.data[0]) download(res.data[0].url);
        })
        .catch(() => this.$message.info(this.$t("error.download_failed") + ""));
    }
  }
});
